import * as React from "react";
import { cx } from "utils/join-classnames";
import { IconNames } from "core/models";
import { Button } from "ui/components";
import styles from "./PopOver.module.scss";

interface Props {
    icon: IconNames;
    type?: "primary" | "secondary" | "icon" | "function";
    disabled?: boolean;
    orientation?: "left" | "right";
    className?: string;
    children: React.ReactNode;
}

const PopOver: React.FC<Props> = ({
    icon,
    disabled,
    orientation = "right",
    className,
    children,
    type = "primary",
}) => (
    <div className={cx(styles.popover, className)}>
        <Button
            type={type}
            theme="light"
            icon={icon}
            disabled={disabled}
            className={styles.popover__btn}
        />
        <div
            className={cx(
                styles.popover__options,
                orientation === "left" ? styles.popover__options__left : null,
            )}
        >
            <div className={styles.popover__triangle} />
            <div className={styles.popover__options__inner}>{children}</div>
        </div>
    </div>
);

export default React.memo(PopOver);
